// extracted by css-extract-rspack-plugin
export default {"loading-spinner":"aP7kKe","loadingSpinner":"aP7kKe","core-icon":"JfNND7","coreIcon":"JfNND7"};